import { useEffect, useState } from 'react'

const DESKTOP_MIN_WIDTH = 1024 // Tailwind lg breakpoint

/** True when the window is narrower than a laptop screen */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < DESKTOP_MIN_WIDTH)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  return isMobile
}
